<div class="flex flex-1 flex-col justify-center space-y-5 max-w-md mx-auto lg:mt-10 xs:mt-10">
    <div class="flex flex-col space-y-2 text-center m-5">
        
        <h2 class="lg:mt-6 xs:mt-1  text-center text-3xl leading-9 font-extrabold text-[#7B68EE]">
            Reset Password 
           </h2>
          
        <p class="text-md md:text-xl text-blue-500">Want Change Password?</p>
    </div>
    <div class="flex flex-col max-w-md space-y-5">
        <div class="w-full px-3">
            <div>
                <label for="fName" class="mb-3 block text-base font-medium text-[#07074D]">Enter Current Password</label>
                <input type="password" name="currentPassword" id="currentPassword" placeholder="Enter Current Password" [(ngModel)]="currentPassword" [ngModelOptions]="{standalone: true}"
                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
            </div>
        </div>
        <div class="w-full px-3">
            <div class="mb-5">
                <label for="newPassword" class="mb-3 block text-base font-medium text-[#07074D]">Enter New Password</label>
                <input type="password" name="newPassword" id="newPassword" placeholder="Enter New Password" [(ngModel)]="newPassword" [ngModelOptions]="{standalone: true}"
                   
                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                <span *ngIf="newPassword.length > 0 && newPassword.length < 6" class="text-red-500 text-sm">Password must be at least 6 characters long</span>
            </div>
        </div>
        <div class="w-full px-3">
            <div class="mb-5">
                <label for="confirmPassword" class="mb-3 block text-base font-medium text-[#07074D]">Enter Confirm Password</label>
                <input type="password" name="confirmPassword" id="confirmPassword" placeholder="Enter confirm Password" [(ngModel)]="confirmPassword" [ngModelOptions]="{standalone: true}"
                   
                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
            </div>
        </div>
        <div  class="mx-auto">
        <button class="addbtn flex items-center justify-center flex-none px-3 py-2 md:px-4 md:py-3 border-2 rounded-lg font-medium text-white" 
            [disabled]="newPassword.length < 6" 
            (click)="updatePassword()">
            Update
        </button>
    </div>
    </div>
</div>
